import CopyProductsToWishlist from "./copyProductToWishList";
import ActivateTabFunc from "../tabPanel/components/activateTabFunc";
import LoadWishLists from "./loadWishLists";
import SendTipAFriend from "../sendTipaAfriend";
import {UpdateUserPass} from "../account/passwordDialogs"
import {
  ValidateEmail,
  ValidateName,
  ValidateSecondName
} from "../validators/indexValidator";

export default function profileJs() {
  $(function () {
    if ($(".profile-page").length > 0) {
      initProfile();
    }
    
    $(window).on('click', function (e) {
      let target = e.target;
      let targetParent = $(target).parent();
      if ($(target).hasClass("copy-towish-func")) {
        var dataCopy = $(target).attr('data-copy');
        var wishListId = $(target).attr('data-wishlist-id');
        
        CopyProductsToWishlist($(target), dataCopy, wishListId);
      }
      
      if ($(target).hasClass('send-wishlist-func')) {
        SendWishlist($(target));
      }
      
      if ($(targetParent).hasClass('pagination-func')) {
        let pageNumber = +targetParent.attr('data-backlog').split(',')[0];
        let backlog = targetParent.attr('data-backlog').split(',')[1] === 'true';
        GetUserOrders(pageNumber, backlog);
        UpScroll();
      }
      
      if ($(target).attr("data-relativeid") || $(target).parent().attr("data-relativeid")) {
        let wishListId = $(target).closest('[data-relativeid]').attr("data-relativeid");
        
        if (wishListId === "#myWishlistsMenuItem") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#myWishlistsMenuItem"]').parent(), LoadWishLists());
          SetBold($('.filter-list [data-relativeid="#myWishlistsMenuItem"]'));
        }
        if (wishListId === "#myRecensionsMenuItem") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#myRecensionsMenuItem"]').parent(), LoadUserReviews());
          SetBold($('.filter-list [data-relativeid="#myRecensionsMenuItem"]'));
        }
        if (wishListId === "#myOrdersMenuItem") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#myOrdersMenuItem"]').parent(), GetUserOrders(1, false));
          SetBold($('.filter-list [data-relativeid="#myOrdersMenuItem"]'));
        }
        if (wishListId === "#myOrdersHistoryMenuItem") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#myOrdersHistoryMenuItem"]').parent(), GetUserOrders(1, true));
          SetBold($('.filter-list [data-relativeid="#myOrdersHistoryMenuItem"]'));
        }
        if (wishListId === "#filterMyDetails") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#filterMyDetails"]').parent());
          SetBold($('.filter-list [data-relativeid="#filterMyDetails"]'));
        }
        if (wishListId === "#ChangePassword") {
          ActivateTabFunc($('.tabs-nav [data-relativeid="#ChangePassword"]').parent());
          SetBold($('.filter-list [data-relativeid="#ChangePassword"]'));
        }
      }
      
      if ($(target).parents().hasClass('show-wish-list-func') || $(target).hasClass('show-wish-list-func')) {
        let wishListId = $(target).closest('.show-wish-list-func').attr('data-wishid');
        ShowSendWishlistModal(wishListId);
      }
      
      if ($(target).parents().hasClass('show-copy-wishlist-func') || $(target).hasClass('show-copy-wishlist-func')) {
        let wishListId = $(target).closest('.show-copy-wishlist-func').attr('data-wishid');
        ShowCopyWishlistModal(wishListId);
      }
      
      if ($(target).parents().hasClass('delete-wishlist-popup-func') || $(target).hasClass('delete-wishlist-popup-func')) {
        let wishListId = $(target).closest('.delete-wishlist-popup-func').attr('data-wishid');
        DeleteWishListPopup(wishListId);
      }
      
      if ($(target).parents().hasClass('recension-copy-wishlist-func') || $(target).hasClass('recension-copy-wishlist-func')) {
        let wishListId = $(target).closest('.recension-copy-wishlist-func').attr('data-wishid');
        ShowCopyWishlistModal(null, wishListId);
      }
      
      if ($(target).parents().hasClass('show-Tipa-frendmodal-func') || $(target).hasClass('show-Tipa-frendmodal-func')) {
        let wishListId = $(target).closest('.show-Tipa-frendmodal-func').attr('data-wishid');
        ShowTipAFriendModal(wishListId);
      }
      
      if ($(".profile-page").length > 0) {
        if ($(target).hasClass('send-tipa-frend-func')) {
          SendTipAFriend();
        }
      }
      
      if ($(target).hasClass('update-user-pass-func')) {
        UpdateUserPass();
      }
      
      if ($(target).hasClass('update-user-profile-func')) {
        UpdateUserProfile();
      }
      
      if ($(target).hasClass('edit-button-complete')) {
        let wishListId = $(target).attr('data-wishListId');
        SaveWishlistName(wishListId);
      }
    });
  });
  
  function initProfile() {
    $(document.body).on("click", ".check-wl-products", function () {
      var wlId = $(this).data("wl-id");
      var checkboxes = $(".check-product[data-product-wl-id='" + wlId + "']");
      var parent = $(this);
      checkboxes.each(function () {
        if (!$(this).prop('disabled')) {
          $(this).prop("checked", parent.prop("checked"));
          $(this).attr("checked", parent.attr("checked"));
        }
      });
    });
    
    $(document.body).on("change", ".order-filter select", function () {
      var parent = $(this).parents(".profile-product-group");
      var wishlistId = parent.data("wl-id");
      var sort = $(this).find(":selected").val();
      SortWishlist(wishlistId, sort, parent);
    });
    
    $(document.body).on("click", ".check-product", function () {
      var wlId = $(this).data("product-wl-id");
      
      if (!$(this).prop("checked")) {
        $(".check-wl-products[data-wl-id='" + wlId + "']").prop("checked", false);
        $(this).parents(".product_item").removeClass("selected");
      } else {
        var $checkboxes = $(".check-product[data-product-wl-id='" + wlId + "']");
        $(this).parents(".product_item").addClass("selected");
        var isAllChecked = true;
        $checkboxes.each(function () {
          if (!$(this).prop("checked")) {
            isAllChecked = false;
            return;
          }
        });
        
        if (isAllChecked) {
          $(".check-wl-products[data-wl-id='" + wlId + "']").prop("checked", "checked");
          $(".check-wl-products[data-wl-id='" + wlId + "']").attr("checked", "checked");
        }
      }
    });
    
    LoadWishlistsWithoutProducts();
    $("#tab5").on("click", function () {
      LoadUserReviews();
    });
    
    GetUserOrders(1, false);
    GetOrderCount(1);
    profileEditIcon();
  }
  
  function UpdateUserProfile() {
    
    var containerName = ".user-profile-form";
    var valid = true;
    var Name = $(containerName + " input.tbxName");
    var SecondName = $(containerName + " input.tbxSecondName");
    var Login = $(containerName + " input.tbxLogin");
    var Email = $(containerName + " input.tbxEmail");
    var Phone = $(containerName + " input.tbxMobile");
    var Address = $(containerName + " input.tbxAddress");
    var PostNumber = $(containerName + " input.tbxPostNumber");
    var City = $(containerName + " input.tbxCity");
    
    var validArr = [];
    
    validArr.push(ValidateName(Name));
    validArr.push(ValidateSecondName(SecondName));
    validArr.push(ValidateEmail(Email, null, null, null, null));
    
    
    for (var i = 0; i < validArr.length; i++) {
      if (!validArr[i]) {
        valid = false;
        break;
      }
    }
    
    if (valid) {
      
      var obj = {};
      obj.FirstName = Name.val();
      obj.LastName = SecondName.val();
      obj.Login = Login.val();
      obj.Mobile = Phone.val();
      obj.Email = Email.val();
      obj.CO = $(containerName + " input.tbxCO").val();
      obj.Address = Address.val();
      obj.Zip = PostNumber.val();
      obj.City = City.val();
      obj.CountryId = $(containerName + " select.ddlCountry22").val();
      obj.CountryText = $(containerName + " select.ddlCountry22 option:selected").text();
      obj.SubscribeToCatalog = $("input.chbCatalog").is(':checked');
      obj.SubscribeToNews = $("input.chbNews").is(':checked');
      $.ajax({
        data: JSON.stringify(obj),
        async: false,
        contentType: "application/json",
        type: "POST",
        url: "/api/account/UpdateUserProfile",
        beforeSend: function () {
          $(".user-profile-form .btn").addClass("show-loader");
        },
        complete: function () {
          $(".user-profile-form .btn").removeClass("show-loader");
        },
        success: function (data) {
          if (data != null) {
            if (data.IsSuccess) {
              location.reload();
            } else {
              if (data.Message == "AliasNotUnique") {
                $("span[id$='cvAlias']").show();
                $("span[id$='cvAlias']").addClass('is-visible');
              }
              if (data.Message == "EmailNotUnique") {
                $("span[id$='cvEmail']").show();
                $("span[id$='cvEmail']").addClass('is-visible');
              }
            }
          }
        }
      });
    }
  }
  
  function LoadWishlistsWithoutProducts() {
    $.ajax({
      url: "/api/CustomersWishlist/GetWishlists",
      cache: false,
      dataType: "json",
      success: function (data) {
        $("#myWishlistsCounter").html(" (" + data.Wishlists.length + ")");
      }
    });
  }
  
  function LoadUserReviews() {
    $(".newUserReviews").children().not("li.spinner").remove();
    $.getJSON("/api/CustomerReviews", function (data) {
      $('.newUserReviews').find('.visa-loader-specific').attr('style', '');
      if (data && data.length) {
        var template = $.templates('#userReviewTemplate');
        var outerHtml = template.render({UserReviews: data});
        $(".newUserReviews").append(outerHtml);
        
        $("#myRecensionsCounter").html(" (" + data.length + ")");
      }
    });
  }
  
  function GetUserOrders(page, isBacklog) {
    if (isBacklog) {
      $("#ulUserOrdersBackLog").children().not("li.spinner").remove();
    } else {
      $("#ulUserOrders").children().not("li.spinner").remove();
    }
    $.ajax({
      url: "/api/orders?page=" + page + (isBacklog ? "&isOrderBacklog=true" : ""),
      async: true,
      type: "GET",
      contentType: "application/json",
      
      error: function (jqXHR, exception) {
        LogError(jqXHR, exception);
      },
      success: function (data) {
        if (isBacklog) {
          $('#ulUserOrdersBackLog').find('.visa-loader-specific').attr('style', '');
        } else {
          $('#ulUserOrders').find('.visa-loader-specific').attr('style', '');
        }
        if (data.Orders != null && data.Orders.length > 0) {
          if (data.Orders.length > 0) {
            var template = $.templates('#userOrders');
            var outerHtml = template.render(data.Orders);
            if (isBacklog) {
              $(outerHtml).appendTo("#ulUserOrdersBackLog");
            } else {
              $(outerHtml).appendTo("#ulUserOrders");
            }
          }
          if (isBacklog) {
            $("#myBackLogOrdersCounter").html(" (" + data.TotalCount + ")");
          } else {
            $("#myOrdersCounter").html(" (" + data.TotalCount + ")");
          }
          
          var pagingElement = $(".profile-page .pagination");
          pagingElement.children().remove();
          if (data.TotalPages > 1) {
            for (var i = 1; i <= data.TotalPages; i++) {
              if (i == page) {
                pagingElement.append("<li class='active'><span>" + i + "</span></li>");
              } else {
                pagingElement.append("<li class='pagination-func' data-backlog='" + i + "," + isBacklog + "'><a href='javascript:void(0)'>" + i + "</a></li>");
              }
            }
          }
        } else {
          var pagingElement = $(".profile-page .pagination");
          pagingElement.children().remove();
          if (!isBacklog) {
            $("<span>Alla beställningar är skickade.</span> <a id='toOrderTabLink' href='javascript:void(0)'>Se din orderhistorik här.</a>").appendTo("#ulUserOrders");
            $('#toOrderTabLink').on('click', function () {
              SetBold($("#myOrdersHistoryMenuItem"));
              ActivateTabFunc($('#orderhistorik').parent(), GetUserOrders(1, true));
            });
          }
        }
      }
    });
  }
  
  function GetOrderCount(page) {
    $.ajax({
      url: "/api/orders?page=" + page,
      async: true,
      type: "GET",
      contentType: "application/json",
      
      error: function (jqXHR, exception) {
        LogError(jqXHR, exception);
      },
      success: function (data) {
        $('#ulUserOrders').find('.visa-loader-specific').attr('style', '');
        if (data.Orders != null && data.Orders.length > 0) {
          $("#myOrdersCounter").html(" (" + data.TotalCount + ")");
        }
      }
    });
  }
  
  function UpScroll() {
    $('html, body').animate({
      scrollTop: $("#scrollTo").offset().top
    }, 2000);
  }
  
  
  function SetBold(link) {
    var $link = link;
    $('.sidebar .filter-list li a').css({fontWeight: "normal"});
    $link.css({fontWeight: "bold"});
  }
  
  function DeleteWishListPopup(wishlistId) {
    var $infoPopup = $('#delete-wishlist-popup');
    
    $.featherlight($infoPopup, {
      afterContent: function () {
        var confirmBtn = this.$content.find(".featherlight-confirm");
        confirmBtn.on("click", function () {
          DeleteWishlist(wishlistId);
          $.featherlight.current().close();
        });
      },
      afterClose: function () {
        var confirmBtn = this.$content.find(".featherlight-confirm");
        confirmBtn.off("click");
      }
    });
  }
  
  function DeleteWishlist(wishlistId) {
    var wishlist = {};
    wishlist.WishListId = wishlistId;
    wishlist.Products = [];
    var $checkboxes = $("#tab3 .check-product[data-product-wl-id='" + wishlistId + "']");
    
    $checkboxes.each(function () {
      if ($(this).prop("checked")) {
        var product = {};
        product.ProductIdentifier = $(this).data("productidentifier").toString();
        wishlist.Products.push(product);
      }
    });
    $.ajax({
      type: "POST",
      url: "/api/CustomersWishlist/DeleteProducts",
      data: JSON.stringify(wishlist),
      contentType: "application/json",
      success: function (data) {
        if (data) {
          LoadWishLists();
        }
      }
    });
  }
  
  function SendWishlist(sender) {
    var parent = sender.parents("#sendwishlist-dialog");
    var wishlistId = parent.data("wl-id");
    var emailsLi = $(".sendwishlist-emails", parent);
    var emailsTb = emailsLi.find(".inputTextBox");
    var emailsValidator = emailsLi.find(".validator");
    
    var greetingLi = $(" .sendwishlist-greeting", parent);
    var greetingTb = greetingLi.find(".inputTextBox");
    var greetingValidator = greetingLi.find(".validator");
    var divError = $(" .divError", parent).hide();
    var divEmailSent = $(" .divEmailSent", parent).hide();
    
    emailsTb.removeClass("error");
    emailsValidator.addClass('is-hidden');
    greetingTb.removeClass("error");
    greetingValidator.addClass('is-hidden');
    
    if (emailsTb.val() == "") {
      emailsTb.addClass("error");
      emailsValidator.addClass('is-visible');
      return;
    }
    if (greetingTb.val() == "") {
      greetingTb.addClass("error");
      greetingValidator.addClass('is-visible');
      return;
    }
    
    var wishlist = {};
    wishlist.WishlistId = wishlistId;
    wishlist.Emails = emailsTb.val();
    wishlist.Greeting = greetingTb.val();
    $.ajax({
      type: "POST",
      url: "/api/CustomersWishlist/SendWishlist",
      data: JSON.stringify(wishlist),
      contentType: "application/json",
      success: function (data) {
        if (data) {
          if (data.Error) {
            divError.show();
            divError.find(".errorMessage").html(data.Error);
          } else if (data.Result) {
            divEmailSent.show();
            divEmailSent.find("span").html(data.Result);
          }
        }
      }
    });
  }
  
  function ShowCopyWishlistModal(wlId, productId) {
    if (wlId) {
      var isChecked = $(".check-product[data-product-wl-id='" + wlId + "']:checked").length > 0;
      
      if (!isChecked) {
        alert('Välj produkter');
        return false;
      }
    }
    var $infoPopup = $('#copytowishlist-dialog');
    $infoPopup.data("wl-id", wlId);
    $infoPopup.data("product-id", productId);
    $.ajax({
      url: "/api/CustomersWishlist/GetWishlists",
      cache: false,
      dataType: "json",
      success: function (data) {
        var template = $.templates('#copyToWishlistTemplate');
        var outerHtml = template.render(data);
        $infoPopup.find(".content").html(outerHtml);
        $infoPopup.find(".section-heading h2").html(data.EditWishHeading);
        if (wlId) {
          var wlLinkButton = $("#copytowishlist-dialog .wishListListing a[data-wishlist-id=" + wlId + "]");
          if (wlLinkButton.length > 0) {
            wlLinkButton.hide();
            wlLinkButton.next().hide();
            if ($("#copytowishlist-dialog .wishListListing a").length == 1) {
              $("#copytowishlist-dialog .currentWishlists").hide();
            }
          }
        }
        $.featherlight($infoPopup, null);
      }
    });
  }
  
  function ShowTipAFriendModal(productId) {
    var $infoPopup = $('#tipafriend-dialog');
    $infoPopup.data("product-id", productId);
    var template = $.templates('#tipafriendForm');
    var outerHtml = template.render();
    $infoPopup.find(".content").html(outerHtml);
    $.featherlight($infoPopup, {persist: 'shared'});
  }
  
  function ShowSendWishlistModal(wlId) {
    var $infoPopup = $('#sendwishlist-dialog');
    $infoPopup.data("wl-id", wlId);
    $.featherlight($infoPopup, null);
  }
  
  function SortWishlist(wishListId, sortType, parent) {
    var direction = "desc";
    wishListId = parent.find(".product-list-container").children();
    
    
    var sortSelector = ".product_item-text>a>span";
    if (sortType == "price") {
      sortSelector = ".product_details-holder > .price-value";
    }
    if (sortType == "artist") {
      sortSelector = ".product_item-text>a>strong";
    }
    if (sortType == "stock") {
      sortSelector = ".product_details-holder > .product-status";
    }
    wishListId.sort(function (a, b) {
      var an = $(a).find(sortSelector).text(),
        bn = $(b).find(sortSelector).text();
      if (sortSelector.indexOf("price") > 0) {
        an = an.replace("€", '');
        bn = bn.replace("€", '');
        an = parseFloat(an);
        bn = parseFloat(bn);
      }
      if (an > bn) {
        return direction == "desc" ? 1 : -1;
      }
      if (an < bn) {
        return direction == "desc" ? -1 : 1;
      }
      return 0;
    });
    
    wishListId.detach().appendTo(parent.find(".product-list-container"));
  }
  
  function SaveWishlistName(id) {
    var parent = $(".wishListTitleBar[data-wl-id='" + id + "']");
    var editPanel = parent.find(".edit-title-holder");
    var nameInput = editPanel.find("input.edit-title-input");
    nameInput.removeClass("error");
    var name = nameInput.val();
    
    
    if (name != '') {
      var wishlist = {};
      wishlist.WishListId = id;
      wishlist.Name = name;
      $.ajax({
        type: "POST",
        url: "/api/CustomersWishlist/SaveWishlistName",
        data: JSON.stringify(wishlist),
        contentType: "application/json",
        success: function (data) {
          if (data) {
            LoadWishLists();
            LoadUserReviews();
          } else {
            editPanel.fadeOut(200);
            parent.find('.checkbox-label').fadeIn(200);
            parent.find('.edit-title-icon').fadeIn(200);
          }
        }
      });
    } else {
      nameInput.addClass("error");
    }
  }
  
  function profileEditIcon() {
    $(document.body).on("click", ".edit-title-icon", function () {
      $(this).fadeOut(200);
      $(this).siblings('.edit-title-holder').fadeIn(200);
      $(this).siblings('.checkbox-label').fadeOut(200);
    });
  }
}

export function userIsLoggedIn() {
  return $(".login-popup-trigger").length === 0;
}
